module.exports = {"620722101":"洪水镇","620722102":"六坝镇","620722103":"新天镇","620722104":"南古镇","620722105":"永固镇","620722106":"三堡镇","620722200":"南丰乡","620722201":"民联乡","620722203":"顺化乡","620722204":"丰乐乡","620722400":"民乐生态工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620722.json
// module id = 2708
// module chunks = 0